import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Courses from './components/Courses';
import About from './pages/About';
import Resume from './pages/Resume';
import GithubResume from './pages/GithubResume';
import FunFactForm from './components/FunFactForm';
import FunFactsDisplay from './pages/FunFactsDisplay';
import Dashboard from './components/Dashboard';
import DatabaseDashboard from './components/DatabaseDashboard';
import PersonalFinanceDashboard from './components/PersonalFinanceDashboard';
import F1HomePage from './pages/f1/F1HomePage';
import F1ChampionshipPage from './pages/f1/F1ChampionshipPage';
import PitstopAnalysisPage from './pages/PitstopAnalysisPage';
import F1DataPage from './pages/f1/F1DataPage';
import F1DataViewerPage from './pages/f1/F1DataViewerPage';
import F1RacesPage from './pages/f1/F1RacesPage';
import F1SeasonsPage from './pages/f1/F1SeasonsPage';
import F1SeasonDetailPage from './pages/f1/F1SeasonDetailPage';
import F1StandingsExplorationPage from './pages/f1/F1StandingsExplorationPage';
import F1DriversPage from './pages/f1/F1DriversPage';
import F1DriverDetailPage from './pages/f1/F1DriverDetailPage';
import F1TrackDetailPage from './pages/f1/F1CircuitDetailPage';
import F1RaceDetailPage from './pages/f1/F1RaceDetailPage';
import F1TeamsPage from './pages/f1/F1TeamsPage';
import F1TeamDetailPage from './pages/f1/F1TeamDetailPage';
import F1CircuitsPage from './pages/f1/F1CircuitsPage';
import F1AwardsPage from './pages/f1/F1AwardsPage';
import GrillTheGridPage from './pages/f1/GrillTheGridPage';
import LoaderPage from './pages/LoaderPage';
import AdminPage from './pages/AdminPage';
import JsonComparePage from './pages/JsonComparePage';
import ToolsPage from './pages/ToolsPage';
//import SystemDiagram from './pages/SystemDiagram';
import { ThemeProvider } from './contexts/ThemeContext';
import { DatabaseProvider } from './contexts/DatabaseContext';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Navigation from './components/Navigation';
import CookieConsent from 'react-cookie-consent';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <DatabaseProvider>
          <ThemeProvider>
            <Router>
              <Navigation />
              <main>
                <Routes>
                  <Route path='/' element={<About/>}/>
                  <Route path="/courses/" element={<Courses/>}></Route>
                  <Route path="/about/" element={<About/>}></Route>
                  <Route path="/fun-facts" element={<FunFactForm/>}></Route>
                  <Route path="/fun-facts-display" element={<FunFactsDisplay/>}></Route>
                  <Route path="/dashboard/" element={<Dashboard/>}></Route>
                  <Route path="/database/" element={<DatabaseDashboard/>}></Route>
                  <Route path="/finance/" element={<PersonalFinanceDashboard/>}></Route>
                  <Route path="/f1" element={<F1HomePage/>}></Route>
                  <Route path="/f1/championship" element={<F1ChampionshipPage/>}></Route>
                  <Route path="/f1/pitstops" element={<PitstopAnalysisPage/>}></Route>
                  <Route path="/f1/data" element={<F1DataPage/>}></Route>
                  <Route path="/f1/data-viewer" element={<F1DataViewerPage/>}></Route>
                  <Route path="/f1/races" element={<F1RacesPage/>}></Route>
                  <Route path="/f1/races/:raceId" element={<F1RaceDetailPage/>}></Route>
                  <Route path="/f1/seasons" element={<F1SeasonsPage/>}></Route>
                  <Route path="/f1/seasons/:year" element={<F1SeasonDetailPage/>}></Route>
                  <Route path="/f1/seasons/:year/standings-exploration" element={<F1StandingsExplorationPage/>}></Route>
                  <Route path="/f1/drivers" element={<F1DriversPage/>}></Route>
                  <Route path="/f1/drivers/:driverId" element={<F1DriverDetailPage/>}></Route>
                  <Route path="/f1/circuits" element={<F1CircuitsPage/>}></Route>
                  <Route path="/f1/circuits/:circuitId" element={<F1TrackDetailPage/>}></Route>
                  <Route path="/f1/teams" element={<F1TeamsPage/>}></Route>
                  <Route path="/f1/teams/:constructorId" element={<F1TeamDetailPage/>}></Route>
                  <Route path="/f1/circuits" element={<F1CircuitsPage/>}></Route>
                  <Route path="/f1/awards" element={<F1AwardsPage/>}></Route>
                  <Route path="/f1/grill-the-grid" element={<GrillTheGridPage/>}></Route>
                  <Route path="/loader" element={<LoaderPage/>}></Route>
                  <Route path="/resume" element={<Resume/>}></Route>
                  <Route path="/tools" element={<ToolsPage/>}></Route>
                  <Route path="/tools/json-compare" element={<JsonComparePage/>}></Route>
                  <Route path="/github-resume" element={<GithubResume/>}></Route>
                  {/* <Route path="/system-diagram" element={<SystemDiagram/>}></Route> */}
                  <Route path="/admin" element={<AdminPage/>}></Route>
                </Routes>
              </main>
              <CookieConsent
                location="bottom"
                buttonText="Accept"
                declineButtonText="Decline"
                cookieName="sydneyFerrisCookieConsent"
                style={{ background: "#2B373B", color: "white" }}
                buttonStyle={{ background: "#4CAF50", color: "white", fontSize: "13px" }}
                declineButtonStyle={{ background: "#737373", color: "white", fontSize: "13px" }}
                expires={365}
                enableDeclineButton
                onDecline={() => {
                  console.log('User declined cookies');
                }}
                onAccept={() => {
                  console.log('User accepted cookies');
                }}
              >
                This website uses cookies to enhance your experience and for authentication purposes.{" "}
                <span style={{ fontSize: "10px" }}>By using this site, you agree to our use of cookies.</span>
              </CookieConsent>
            </Router>
          </ThemeProvider>
        </DatabaseProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
